import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { PersonSubtitle } from '@core/tellent-assistant-types';
import { AvatarComponent } from '@core/user-interface-legacy';

interface PersonRowData {
  readonly name: string;
  readonly avatarUrl?: string | null;
  readonly initials?: string | null;
  readonly subtitle?: PersonSubtitle | null;
}

@Component({
  selector: 'rt-list-row-person',
  imports: [AvatarComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-row-person.component.html',
  styleUrl: './list-row-person.component.less',
})
export class ListRowPersonComponent {
  protected readonly avatarType = computed<'image' | 'initials'>(() =>
    this.data().avatarUrl ? 'image' : 'initials',
  );

  public readonly data = input.required<PersonRowData>();
  public readonly avatarSize = input<'small-x' | 'small'>('small');
}
